module.exports = __webpack_public_path__ + "img/puberty-decal-26.9968999c.png";